import { createContext, useContext } from "react";
import { useUser as useUserHook } from "../hooks/use-user";

const UserContext = createContext<any>(null);

export function UserProvider({ children }: { children: React.ReactNode }) {
  const userStore = useUserHook();
  return (
    <UserContext.Provider value={userStore}>
      {children}
    </UserContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useUser() {
  return useContext(UserContext);
}
